import type { LandingCopy } from './types'

export const landingRu: LandingCopy = {
  heroTitle: 'Понимайте английский прямо во время чтения.',
  heroSubtitleLines: ['Нажмите на любое слово.', 'Мы объясним его.', 'Вы его запомните.'],
  demoHint: 'Регистрация не нужна',
  demoReadLabel: 'Читать',
  demoUnderstandLabel: 'Понять',
  demoTapHint: 'Нажмите на подсвеченное слово, чтобы увидеть значение',
  demoMeans: 'Значение',
  demoInContext: 'В этом предложении',
  demoExampleLabel: 'Пример',
  demoLocalizedNote: 'Зарегистрируйтесь, чтобы сохранять слова и встречать их снова в повторениях.',
  signUpToSave: 'Зарегистрируйтесь, чтобы сохранять слова',
  savedNudge: 'Сохранено — завтра повторите «{word}».',
  capabilitiesTitle: 'Двигатель вашего прогресса',
  capabilitiesSubtitle:
    'Не просто чтение. Слова, которые вы выбираете, становятся статьями, практикой, тестами и повторением — один цикл, который непрерывно ведёт вперёд.',
  capabilities: [
    {
      title: 'Читать и понимать',
      body: 'Нажмите на слово или фразу — объяснение в контексте.',
    },
    {
      title: 'Ваш словарь',
      body: 'Сохраняйте важное — личный список для роста.',
    },
    {
      title: 'Повторение',
      body: 'Интервальное повторение, когда почти забыли.',
    },
    {
      title: 'Статьи по вашим словам',
      body: 'ИИ пишет тексты на вашем уровне вокруг сохранённых слов.',
    },
    {
      title: 'Практика',
      body: 'Истории и уроки из слов, которые вы уже знаете.',
    },
    {
      title: 'Тесты',
      body: 'Проверьте себя и посмотрите, что действительно усвоилось.',
    },
  ],
  finalTitle: 'Готовы превратить слова в прогресс?',
  getStarted: 'Начать бесплатно',
  signIn: 'Войти',
  footerFaq: 'FAQ',
  footerPrivacy: 'Политика конфиденциальности',
  footerTerms: 'Условия использования',
  localeSwitcherLabel: 'Язык',
}
